module.exports = "/_next/static/images/0b4cb70615adca1723cd53e4b702cded-roxinho-scene-card-with-phone-xs@1x.jpg";